var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68441 1.9488C2.09436 1.9488 1.61604 2.42713 1.61604 3.01718V14.983C1.61604 15.573 2.09436 16.0514 2.68441 16.0514H11.2314C11.8215 16.0514 12.2998 15.573 12.2998 14.983V6.79001C12.2998 6.73334 12.2773 6.67899 12.2372 6.63892L7.60968 2.01138C7.56961 1.97131 7.51526 1.9488 7.45859 1.9488H2.68441ZM0.333984 3.01718C0.333984 1.71907 1.38631 0.666748 2.68441 0.666748H7.45859C7.85528 0.666748 8.23572 0.824333 8.51623 1.10484L13.1438 5.73237C13.4243 6.01287 13.5818 6.39332 13.5818 6.79001V14.983C13.5818 16.2811 12.5295 17.3334 11.2314 17.3334H2.68441C1.38631 17.3334 0.333984 16.2811 0.333984 14.983V3.01718Z",
    fill: "#5C6075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.ad27617793dc09a01f309d6f60bff452.svg";
export { ForwardRef as ReactComponent };